<template>
  <FormLayout title="Thêm mới tài khoản kế toán">
    <template v-slot:form>
      <InstallmentForm
        :form-data="formData"
        :errors="errors"
      />
    </template>
    <template v-slot:actions>
      <FormActions
        :loading="submitting"
        @save="createInstallment(formData)"
        @cancel="handleCancel"
        :cancel-route="{
          name: 'list-installment',
        }"
      />
    </template>
  </FormLayout>
</template>

<script>
import { SET_BREADCRUMB } from '@/core/services/store/modules/breadcrumbs.module';
import { handleError, makeToastSuccess } from '../../../../utils/common';
import FormActions from '../shared/components/FormActions.vue';
import FormLayout from '../shared/components/FormLayout.vue';
import InstallmentForm from '../shared/components/InstallmentForm.vue';
import installmentFormMixin from '../shared/mixins/installmentFormMixin';

export default {
  name: 'InstallmentCategoryAdd',
  components: {
    InstallmentForm,
    FormActions,
    FormLayout,
  },
  mixins: [installmentFormMixin],
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: 'Dịch vụ trả góp', route: '/installments' },
      { title: 'Thêm mới dịch vụ trả góp', route: '/add-installment' },
    ]);
  },
  methods: {
    async handleSave() {
      if (!this.validateForm(this.formData)) return;

      this.loading = true;
      try {
        await this.$store.dispatch(
          'installmentCategory/createCategory',
          this.formData,
        );
        makeToastSuccess('Thêm mới tài khoản thành công');
        this.$router.push({
          name: 'list-installment',
        });
      } catch (error) {
        handleError(error);
      } finally {
        this.loading = false;
      }
    },
    handleCancel() {
      this.$router.push({
        name: 'list-installment',
      });
    },
  },
};
</script>
